import { GetStarted } from "../components/Sections/DashboardSummary/GetStarted";
import RecentActivityTable from "../components/Tables/RecentActivityTable";
import { Banner } from "../components/Sections/DashboardSummary/Banner";

export function Summary() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-10">

      {/* Welcome Banner with Key Stats */}
      <Banner />

      {/* Quick Actions / Get Started */}
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Get Started
        </h3>
        <GetStarted />
      </div>

      {/* Recent Activity Table */}
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Recent Activity
        </h3>
        <RecentActivityTable />
      </div>
    </div>
  );
}